var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{staticClass:"c-text-field",attrs:{"type":"date","label":_setup.props.label,"value":_setup.valueISO,"disabled":_setup.props.disabled,"placeholder":_setup.props.placeholder,"prepend-icon":"mdi-calendar","outlined":"","hide-details":""},on:{"change":function($event){return _setup.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }